// extracted by mini-css-extract-plugin
export default {"sidebarContanier":"TeamProfileSidebar_sidebarContanier__4+ss0","disclosed":"TeamProfileSidebar_disclosed__MgGyn","discloseBtn":"TeamProfileSidebar_discloseBtn__ofvla"};